import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { registerTokenCallbacks } from '../utils/axiosSetup';

/**
 * Hook to register AuthContext token callbacks globally
 * Call this once in a component that has access to AuthContext
 * (e.g., inside or below the AuthProvider)
 */
export const useRegisterTokenCallbacks = () => {
  const { accessToken, setAccessToken, deleteAccessToken } = useAuth();

  useEffect(() => {
    registerTokenCallbacks({
      getToken: () => localStorage.getItem('accessToken'),
      setToken: setAccessToken,
      getRefreshToken: () => localStorage.getItem('refreshToken'),
      clearTokens: () => {
        deleteAccessToken();
        localStorage.removeItem('refreshToken');
      }
    });
  }, [accessToken, setAccessToken, deleteAccessToken]);
};
